(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function(){
  function initStock(root){
    if (!root || root.dataset.fstInit) return;
    root.dataset.fstInit = '1';
    var inv = {};
    (root.getAttribute('data-inv') || '').split(',').forEach(function(pair){
      var p = pair.split(':'); if (p.length === 2) inv[p[0]] = parseInt(p[1], 10);
    });
    var textEl = root.querySelector('[data-fst-stock-text]');
    function currentId(){
      var f = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
      return f ? f.value : null;
    }
    function update(){
      var id = currentId(); if (!id) return;
      var q = inv[id];
      if (typeof q === 'number' && q > 0 && q < 100){
        textEl.innerHTML = 'Limited drop: only <strong>' + q + '</strong> left in stock!';
        root.hidden = false;
      } else { root.hidden = true; }
    }
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t && (t.name === 'id' || (t.closest && (t.closest('product-variants') || t.closest('[data-js-product-variant]'))))) setTimeout(update, 80);
    });
    setTimeout(update, 400);
  }
  function initSticky(){
    var sticky = document.querySelector('.sticky-add-to-cart--floating');
    if (!sticky || sticky.dataset.fstStickyInit) return;
    sticky.dataset.fstStickyInit = '1';
    var vtext = sticky.querySelector('[data-fst-sticky-vtext]');
    var dot = sticky.querySelector('[data-fst-sticky-dot]');
    var sale = sticky.querySelector('[data-fst-sticky-sale]');
    function selectedOpts(){
      var o = [];
      document.querySelectorAll('product-variants [data-js-product-variant]').forEach(function(g){
        var c = g.querySelector('input:checked'), s = g.querySelector('select');
        if (c) o.push(c.value); else if (s) o.push(s.value);
      });
      return o;
    }
    function update(){
      var o = selectedOpts();
      if (vtext && o.length) vtext.textContent = o.join(' • ');
      if (dot){
        var sw = document.querySelector('.product-variant__item--color input:checked + .product-variant__label .product-variant__item-swatch');
        if (sw){
          var imgEl = sw.tagName === 'IMG' ? sw : sw.querySelector('img');
          var cs = getComputedStyle(sw);
          if (imgEl && imgEl.src){
            dot.style.backgroundImage = 'url("' + imgEl.src + '")'; dot.style.backgroundSize = 'cover'; dot.style.backgroundColor = '';
          } else if (cs.backgroundImage && cs.backgroundImage !== 'none'){
            dot.style.backgroundImage = cs.backgroundImage; dot.style.backgroundSize = 'cover'; dot.style.backgroundColor = '';
          } else {
            dot.style.backgroundColor = cs.backgroundColor; dot.style.backgroundImage = '';
          }
        }
      }
      if (sale){ sale.hidden = !sticky.querySelector('.sticky-add-to-cart__price-compare'); }
    }
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t && (t.name === 'id' || (t.closest && (t.closest('product-variants') || t.closest('[data-js-product-variant]'))))) setTimeout(update, 90);
    });
    setTimeout(update, 450);
    var addBtn = sticky.querySelector('[data-fst-sticky-add]');
    if (addBtn){
      addBtn.addEventListener('click', function(e){
        e.preventDefault();
        var mainBtn = document.querySelector('[data-main-product-add-to-cart]');
        var form = mainBtn ? mainBtn.closest('form') : document.getElementById('product-form-{{ section.id }}');
        var idInput = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
        var vid = idInput ? parseInt(idInput.value, 10) : 0;
        if (!vid) return;
        addBtn.disabled = true;
        // 2026-10-04 (claim test B): the sticky add used to send the bare variant id, so a pre-order added from the sticky
        // bar had no "Ships by" line property (cart, checkout, emails and the thank-you block all read it). Same value the
        // main form sends: cro-urgency's per-variant date, or the form's own product-level property.
        var stickyBody = { id: vid, quantity: 1 };
        try {
          var sbv = (typeof window.__fstShipBy === 'function') ? window.__fstShipBy(String(vid)) : null;
          if (sbv === null || sbv === undefined){
            var sbIn = form ? form.querySelector('input[name="properties[Ships by]"]:not([disabled])') : null;
            sbv = sbIn ? sbIn.value : '';
          }
          if (sbv) stickyBody.properties = { 'Ships by': sbv };
        } catch(err){}
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(stickyBody)
        }).then(function(r){ return r.json(); }).then(function(){
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          if (typeof window.UpcartToggleCart === 'function') window.UpcartToggleCart();
          addBtn.disabled = false;
        }).catch(function(){ addBtn.disabled = false; });
      });
    }
  }
  function fixAtcContrast(){
    var btn = document.querySelector('[data-main-product-add-to-cart]');
    if (!btn) return;
    var m = getComputedStyle(btn).backgroundColor.match(/(\d+)[,\s]+(\d+)[,\s]+(\d+)/);
    if (!m) return;
    var lum = 0.299 * (+m[1]) + 0.587 * (+m[2]) + 0.114 * (+m[3]);
    var color = lum < 140 ? '#ffffff' : '#1a1a1a';
    btn.style.setProperty('color', color, 'important');
    btn.querySelectorAll('span').forEach(function(el){ el.style.setProperty('color', color, 'important'); });
  }
  function watchAtc(){
    var btn = document.querySelector('[data-main-product-add-to-cart]');
    if (!btn) return;
    fixAtcContrast();
    var host = btn.closest('.flex-buttons') || btn.parentNode;
    if (host && window.MutationObserver){
      new MutationObserver(function(){ setTimeout(fixAtcContrast, 30); }).observe(host, { childList: true, subtree: true });
    }
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t && (t.name === 'id' || (t.closest && (t.closest('product-variants') || t.closest('[data-js-product-variant]'))))) setTimeout(fixAtcContrast, 220);
    });
  }
  function guardLoader(){
    // The theme shows the add-to-cart spinner via `.add-to-cart.working` (hides .button__text,
    // shows .button__loader). Something adds `.working` spuriously on variant change (only in a
    // focused tab), which reads as the button "disappearing -> reload circle -> popping back".
    // The CSS suppresses that spinner unless `.fst-adding` is present; we add `.fst-adding` ONLY
    // during a genuine add-to-cart, so a spurious `.working` can never render a spinner.
    document.querySelectorAll('[data-main-product-add-to-cart], .add-to-cart').forEach(function(btn){
      if (btn.dataset.fstLoaderGuard) return;
      btn.dataset.fstLoaderGuard = '1';
      function markAdding(){
        btn.classList.add('fst-adding');
        clearTimeout(btn.__fstAddingTimer);
        btn.__fstAddingTimer = setTimeout(function(){ btn.classList.remove('fst-adding'); }, 5000);
      }
      btn.addEventListener('pointerdown', markAdding, true);
      btn.addEventListener('mousedown', markAdding, true);
      btn.addEventListener('click', markAdding, true);
      var form = btn.closest('form');
      if (form) form.addEventListener('submit', markAdding, true);
      // when the theme clears `.working` (add finished), drop `.fst-adding` too
      new MutationObserver(function(){
        if (btn.classList.contains('fst-adding') && !btn.classList.contains('working')){
          clearTimeout(btn.__fstAddingTimer);
          btn.__fstAddingTimer = setTimeout(function(){ if(!btn.classList.contains('working')) btn.classList.remove('fst-adding'); }, 60);
        }
      }).observe(btn, { attributes:true, attributeFilter:['class'] });
    });
  }
  var RESTOCK_MSG = "Notify me when it's back";
  function updateSoldOut(){
    var btn = document.querySelector('[data-main-product-add-to-cart]') || document.querySelector('.add-to-cart');
    if (!btn) return;
    var textEl = btn.querySelector('[data-js-product-add-to-cart-text]') || btn.querySelector('.button__text');
    var ctm = btn.querySelector('.ctm-text');
    var L = (window.KROWN && KROWN.settings && KROWN.settings.locales) || {};
    var soldOutLocale = (L.products_sold_out_variant || 'sold out').toString().trim().toLowerCase();
    var cur = textEl ? (textEl.textContent || '').trim().toLowerCase() : '';
    // Sold out = button disabled AND its text is the theme's sold-out wording (NOT a "choose options" state)
    // window.__fstCappedNow (cro-urgency, 2026-09-29): a keep-selling size whose incoming batches are all spoken for.
    var isSoldOut = window.__fstCappedNow === true || (btn.classList.contains('disabled') &&
                    (cur === soldOutLocale || cur.indexOf('sold out') > -1 || cur === RESTOCK_MSG.toLowerCase()));
    if (isSoldOut){
      if (textEl && textEl.textContent.trim() !== RESTOCK_MSG) textEl.textContent = RESTOCK_MSG;
      if (ctm){
        // Keep the sub-line occupying space (don't hide it) so the button height matches the
        // in-stock Add-to-Cart exactly — no layout jump when toggling sizes/colors. Swap the
        // "In-Stock: Ready to Ship" copy for a restock line.
        if (!ctm.hasAttribute('data-fst-stock-line')) ctm.setAttribute('data-fst-stock-line', ctm.textContent);
        ctm.hidden = false;
        ctm.textContent = "We’ll email you the moment it’s back";
        ctm.classList.add('ctm-text--restock');
      }
      btn.classList.add('fst-soldout');
    } else {
      if (ctm){
        ctm.hidden = false;
        if (ctm.classList.contains('ctm-text--restock') && ctm.getAttribute('data-fst-stock-line') != null){
          ctm.textContent = ctm.getAttribute('data-fst-stock-line');   // restore in-stock line
        }
        ctm.classList.remove('ctm-text--restock');
      }
      btn.classList.remove('fst-soldout');
    }
  }
  var RESTOCK_KLAVIYO_COMPANY = 'UGE4P7';
  // RESTOCK MODAL MOVED to assets/cro-restock.js so product cards can open the same one.
  // This section only wires the PDP Add-to-Cart button; everything else is in the asset.
  // NB: this is inside {%- raw -%}{% javascript %}{%- endraw -%}, which Shopify does NOT run Liquid
  // through, so comments in here must be JS comments. A Liquid tag would be emitted literally and
  // throw "Unexpected token '%'", killing this entire script block.
  function wireRestockClick(){
    var btn = document.querySelector('[data-main-product-add-to-cart]') || document.querySelector('.add-to-cart');
    if (!btn || btn.dataset.fstRestockWired) return;
    btn.dataset.fstRestockWired = '1';
    btn.addEventListener('click', function(e){
      if (!btn.classList.contains('fst-soldout')) return; // available -> normal add-to-cart
      e.preventDefault(); e.stopImmediatePropagation();    // sold out -> open the branded restock modal
      if (window.fstRestock) window.fstRestock.open();      // no args = read this page, as before
    }, true);
  }

  function updateAtcPrice(){
    // Show the crossed-out original price inside the Add-to-Cart button: " - $55.00 $40.00"
    var btn = document.querySelector('[data-main-product-add-to-cart]') || document.querySelector('.add-to-cart');
    if (!btn || btn.classList.contains('fst-soldout')) return;
    var textEl = btn.querySelector('[data-js-product-add-to-cart-text]') || btn.querySelector('.button__text');
    if (!textEl) return;
    if (!window.__fstPrices){
      var el = document.querySelector('[data-fst-prices]');
      try { window.__fstPrices = JSON.parse(el.textContent); } catch(e){ window.__fstPrices = {}; }
    }
    var idInput = (btn.closest('form') || document).querySelector('[name="id"]') || document.querySelector('[name="id"]');
    var id = idInput ? idInput.value : null;
    var d = id && window.__fstPrices[id];
    if (!d) return;
    if (textEl.hasAttribute('data-show-preorder-wording')) return;
    // Claim test B (snippets/cro-claim-pdp.liquid): a batch-managed pre-order size gets "PRE-ORDER - CLAIM YOUR SIZE" with
    // the price on the sub-line; that painter owns the whole button then, so this one steps aside.
    var fstClaim = window.__fstClaim;
    if (fstClaim && typeof fstClaim.paintButton === 'function' && fstClaim.paintButton()) return;
    var priceEl = textEl.querySelector('.button__price');
    if (!priceEl){
      priceEl = document.createElement('span');
      priceEl.className = 'button__price';
      textEl.appendChild(priceEl);
    }
    // Build the inner structure ONCE, then only swap the number text in place on every
    // variant change. No innerHTML rebuild → the button never reloads/reflows on a color
    // switch; the was/now spans just update their textContent.
    var nowEl = priceEl.querySelector('.button__price-now');
    if (!nowEl){
      priceEl.textContent = ' - ';
      nowEl = document.createElement('span'); nowEl.className = 'button__price-now';
      priceEl.appendChild(nowEl);
    }
    var wasEl = priceEl.querySelector('.button__price-was');
    if (wasEl){ wasEl.remove(); }
    // Sale-aware (Comfrt pass, 2026-09-26): cro-sale exposes window.__fstSale = {map, pct}; the button shows the sale price for
    // variants in the map, computed from the theme's own money string so currency + format match. ONE writer for this button.
    var shown = d.p, sale = window.__fstSale, struck = null, tier = window.__fstTier;
    if (sale && sale.map && sale.map[id]){
      shown = String(d.p).replace(/(\d[\d,]*\.?\d*)/, function(numStr){ var n = parseFloat(numStr.replace(/,/g, '')); return isNaN(n) ? numStr : (n * (100 - sale.pct) / 100).toFixed(2); });
    } else if (tier && tier.n > 1 && tier.full > 0){
      // Bundle tiers (snippets/cro-tiers.liquid, 2026-09-28): with 2 or 3 picked, the button shows the tier total in cents
      // (window.__fstTier = {n, pct, net, full}) and strikes the full price of the same pieces. Tiers never show on sale
      // variants, so the two discounts are never shown stacked here. Formatted from the theme's own money string.
      shown = String(d.p).replace(/(\d[\d,]*\.?\d*)/, (tier.net / 100).toFixed(2));
      struck = String(d.p).replace(/(\d[\d,]*\.?\d*)/, (tier.full / 100).toFixed(2));
    } else if (fstClaim && typeof fstClaim.perkPair === 'function'){
      // Claim test B perk: custom.is_preorder sizes show the pre-order price (5% off since 2026-10-13) with the regular price struck.
      var pk = fstClaim.perkPair(id);
      if (pk && pk.now){ shown = pk.now; struck = pk.was; }
    }
    if (nowEl.textContent !== shown) nowEl.textContent = shown;
    // the struck figure, right after the price, on the SAME basis as the price row above: the regular price while the
    // sale is on (the 20% claim's anchor), the comparable value otherwise; removed when there is nothing to strike
    if (struck === null) struck = (shown !== d.p) ? d.p : (d.c || '');
    var cmpEl = priceEl.querySelector('.button__compare');
    if (struck){
      if (!cmpEl){ cmpEl = document.createElement('s'); cmpEl.className = 'button__compare'; priceEl.appendChild(document.createTextNode(' ')); priceEl.appendChild(cmpEl); }
      if (cmpEl.textContent !== struck) cmpEl.textContent = struck;
    } else if (cmpEl){ cmpEl.remove(); }
  }
  function updateCpvLabels(){
    // Hide the "Comparable Product Value*" column for variants that have no compare-at price
    // (the theme empties the compare element; we follow it so the label never shows alone).
    var col = document.querySelector('[data-fst-cpv-col]');
    if (!col) return;
    var cmp = document.querySelector('[data-js-product-price-compare]');
    col.hidden = !(cmp && cmp.textContent.trim() !== '');
  }
  function updatePayin4(){
    // Keep the "4 interest-free payments of $X" line in sync with the current variant price.
    var amtEl = document.querySelector('[data-fst-payin4-amt]');
    var priceEl = document.querySelector('[data-js-product-price-original]');
    if (!amtEl || !priceEl) return;
    // Read ONE number: the sale price when cro-sale's rewrite is showing (<s>$65</s> $52), else the first amount. The old
    // strip-everything parse turned "$65 $52" into 6552 and printed "$1638.00" on every sale product (found 2026-09-26).
    var src = priceEl.querySelector('.fst-sale-now') || priceEl;
    var raw = (src.textContent || '').trim();
    var m = raw.match(/(\d[\d,]*\.?\d*)/);
    var num = m ? parseFloat(m[1].replace(/,/g, '')) : NaN;
    if (!num || isNaN(num)) return;
    var sym = (raw.match(/^[^0-9]+/) || ['$'])[0].trim() || '$';
    amtEl.textContent = sym + (num / 4).toFixed(2);
  }
  function stripCents(){
    // Quiet pass 2026-08-25: "$69.00" -> "$69" in the price block and the ATC button. Text-node level
    // so the theme's own price rewrites survive; only exact ".00" is touched, "$69.50" stays intact.
    // updatePayin4 is unaffected: parseFloat("$69") still yields 69.
    var roots = document.querySelectorAll('.product-price, [data-main-product-add-to-cart]');
    [].forEach.call(roots, function(root){
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue;
        if (t && t.indexOf('.00') !== -1) {
          var s = t.replace(/([$€£]\s?\d{1,5})\.00(?!\d)/g, '$1');
          if (s !== t) n.nodeValue = s;
        }
      }
    });
  }
  function refreshAtc(){ updateSoldOut(); updateAtcPrice(); updateCpvLabels(); updatePayin4(); stripCents(); }
  window.__fstRefreshAtc = refreshAtc;
  // ---- Loox loading state (2026-08-25) ----
  // loox.js deletes its server-rendered reviews at boot and refills the box lazily: first the
  // #looxReviews div appears empty, then an iframe is inserted whose loox.io content still has to
  // load over the network. On slow connections that is seconds of white void where reviews should
  // be. This marks the box .fst-loox-loading (shimmer + "Loading reviews" in CSS) until the iframe
  // fires load, OR any postMessage arrives from loox.io (their widget streams height messages, which
  // also covers an iframe whose load event fired before we attached), OR a 20s failsafe.
  (function(){
    var tries = 0;
    // clearState marks the box DONE as well as clearing the class, so the MutationObserver's sync
    // can never re-shimmer a widget that has already proven itself alive.
    function clearState(){ var b = document.getElementById('looxReviews'); if (b) { b.dataset.fstLxDone = '1'; b.classList.remove('fst-loox-loading'); } }
    window.addEventListener('message', function(e){ if (e.origin && e.origin.indexOf('loox.io') !== -1) clearState(); });
    function arm(){
      var box = document.getElementById('looxReviews');
      if (!box) { if (++tries < 40) setTimeout(arm, 500); return; }
      if (box.dataset.fstLx) return; box.dataset.fstLx = '1';
      var sync = function(){
        if (box.dataset.fstLxDone) return;
        var ifr = box.querySelector('iframe');
        box.classList.add('fst-loox-loading');
        if (ifr && !ifr.dataset.fstLxWired) {
          ifr.dataset.fstLxWired = '1';
          ifr.addEventListener('load', function(){ box.dataset.fstLxDone = '1'; clearState(); });
        }
      };
      sync();
      if (window.MutationObserver) new MutationObserver(sync).observe(box, { childList: true });
      setTimeout(function(){ box.dataset.fstLxDone = '1'; clearState(); }, 20000);
    }
    arm();
  })();
  // The theme rewrites price text on variant change and on section re-render; re-normalize whenever
  // that happens. Writing identical text back does not re-trigger (we only write when changed).
  (function(){
    if (!window.MutationObserver) return;
    var host = document.querySelector('.product-price');
    if (!host || !host.parentElement) return;
    new MutationObserver(function(){ stripCents(); }).observe(host.parentElement, { childList: true, subtree: true, characterData: true });
  })();
  stripCents();
  var FST_MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function fstParseTitleDate(){
    // Prefer the un-stripped original title (the visible H1 has the "(PRE-ORDER M/D)" removed).
    var src = document.querySelector('[data-fst-fulltitle]');
    var title = src ? (src.getAttribute('data-fst-fulltitle') || '') : '';
    if (!title){ var titleEl = document.querySelector('.product-title, [data-js-product-title], .product__title, h1'); title = titleEl ? titleEl.textContent : ''; }
    var m = title.match(/(\d{1,2})\s*\/\s*(\d{1,2})(?:\s*\/\s*\d{2,4})?/);
    if (!m) return null;
    var mo = parseInt(m[1], 10), day = parseInt(m[2], 10);
    if (mo < 1 || mo > 12 || day < 1 || day > 31) return null;
    return FST_MONTHS[mo - 1] + ' ' + day;
  }
  function fillShipBy(){
    // If the metafield set a date, Liquid already rendered it. Otherwise parse "M/D" from the title.
    var dateStr = fstParseTitleDate();
    if (!dateStr) return;
    var btn = document.querySelector('[data-fst-btn-preorder]');
    if (btn && !btn.getAttribute('data-shipdate')){
      btn.textContent = 'Pre-Order · Ships ' + dateStr;
    }
    var tick = document.querySelector('[data-fst-preorder-text]');
    if (tick && !tick.getAttribute('data-shipdate')){
      tick.textContent = 'Pre-Order · Ships ' + dateStr;
    }
  }
  function initColorGallery(){
    var gallery = document.querySelector('[data-js-product-gallery]');
    if (!gallery) return;
    var items = [].slice.call(gallery.querySelectorAll('.product-gallery-item'));
    if (items.length < 2) return;
    // Each photo is tagged to a color via data-fst-color (parsed from "Color | caption" alt text).
    // Auto-enable the per-color filter only when the gallery actually contains 2+ colors.
    var distinct = {};
    items.forEach(function(it){ var c = (it.getAttribute('data-fst-color') || '').trim(); if (c) distinct[c] = true; });
    if (Object.keys(distinct).length < 2) return;
    function colorOf(it){ return (it.getAttribute('data-fst-color') || '').trim().toLowerCase() || null; }
    var thumbs0 = [].slice.call(document.querySelectorAll('.thumbnail'));
    items.forEach(function(it, i){ it.__fstThumb = thumbs0[i] || null; });
    // Version photos (Hold Your Horses): with no colour option, the selected size's version is the group.
    var vg = null;
    try { var vgEl = document.querySelector('[data-fst-version-groups]'); if (vgEl) vg = JSON.parse(vgEl.textContent); } catch(e){ vg = null; }
    function selectedColor(){
      var c = document.querySelector('.product-variant__item--color .product-variant__input:checked');
      if (c) return c.value.trim().toLowerCase();
      if (vg && vg.in && vg.pre){
        var idEl = document.querySelector('product-form form [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
        var sb = (idEl && typeof window.__fstShipBy === 'function') ? window.__fstShipBy(String(idEl.value)) : '';
        return String(sb ? vg.pre : vg.in).trim().toLowerCase();
      }
      return null;
    }
    // Swatch values can carry suffixes (e.g. "Red (JESUS HEALS)") — match if either is a prefix of the other.
    function matches(itemColor, sel){
      if (!itemColor || !sel) return false;
      return sel === itemColor || sel.indexOf(itemColor) === 0 || itemColor.indexOf(sel) === 0;
    }
    function curItems(){ return [].slice.call(gallery.querySelectorAll('.product-gallery-item')); }
    function curThumbs(){ return [].slice.call(document.querySelectorAll('.thumbnail')); }
    function hideShow(color){
      var its = curItems(), ths = curThumbs();
      var hasAny = its.some(function(it){ return matches(colorOf(it), color); });
      its.forEach(function(it, i){
        var mc = colorOf(it);
        var show = !hasAny || matches(mc, color) || mc === null; // selected color + shared (untagged) shots
        it.classList.toggle('cpc-media-hidden', !show);
        if (it.__fstThumb) it.__fstThumb.classList.toggle('cpc-media-hidden', !show);
      });
    }
    function showAll(){
      var its = curItems(), ths = curThumbs();
      its.forEach(function(it){ it.classList.remove('cpc-media-hidden'); if (it.__fstThumb) it.__fstThumb.classList.remove('cpc-media-hidden'); });
    }
    // 2026-10-09 (Caleb): on phones, a tapped colour's photos move to the FRONT of the swipe gallery (variant's own photo
    // first, then that colour's other photos, then shared photos, then the other colours) and the gallery jumps back to
    // the first photo. Nothing is hidden on phones; the other colours are still there after a swipe.
    var vmedia = {};
    try { var vmEl = document.querySelector('[data-fst-vmedia]'); if (vmEl) vmedia = JSON.parse(vmEl.textContent) || {}; } catch(e){ vmedia = {}; }
    function reorderFor(color){
      var its = curItems(); if (its.length < 2) return;
      var mine = [], shared = [], rest = [];
      its.forEach(function(it){ var c = colorOf(it); if (matches(c, color)) mine.push(it); else if (c === null) shared.push(it); else rest.push(it); });
      if (!mine.length) return;
      var idEl = document.querySelector('product-form form [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var lead = idEl ? String(vmedia[String(idEl.value)] || '') : '';
      if (lead){ for (var k = 0; k < mine.length; k++){ if (mine[k].getAttribute('data-media-id') === lead){ if (k > 0) mine.unshift(mine.splice(k, 1)[0]); break; } } }
      var order = mine.concat(shared, rest);
      var changed = order.some(function(it, i){ return it !== its[i]; });
      if (changed){
        var parent = its[0].parentNode;
        order.forEach(function(it){ parent.appendChild(it); if (it.__fstThumb && it.__fstThumb.parentNode) it.__fstThumb.parentNode.appendChild(it.__fstThumb); });
      }
      var holder = gallery.querySelector('.css-slider-holder');
      var jump = function(){ if (!holder) return; try { holder.scrollTo({ left: 0, behavior: 'auto' }); } catch(e){ holder.scrollLeft = 0; } };
      jump(); setTimeout(jump, 120); setTimeout(jump, 450);   // after the theme's own animated move to the variant photo
    }
    function apply(){
      var color = selectedColor();
      if (!color) return;
      var slider = gallery.querySelector('css-slider');
      if (slider && slider.sliderEnabled){
        // Mobile slider: show all photos, with the selected colour's photos moved to the front.
        showAll();
        reorderFor(color);
        return;
      }
      hideShow(color);
    }
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t && t.closest && (t.closest('.product-variant__item--color') || (vg && t.closest('product-variants')))) setTimeout(apply, vg ? 160 : 40);
    });
    if (vg && window.MutationObserver){
      var vgId = document.querySelector('product-form form [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (vgId){ try { new MutationObserver(function(){ setTimeout(apply, 60); }).observe(vgId, { attributes: true, attributeFilter: ['value'] }); } catch(e){} }
    }
    // Re-evaluate on viewport changes (rotate/resize) so it filters on desktop and shows all on mobile.
    var _fstResizeT;
    window.addEventListener('resize', function(){ clearTimeout(_fstResizeT); _fstResizeT = setTimeout(apply, 200); });
    // After the page is fully loaded: eager-load all photos, then run the first filter — clean startup, no blank switches.
    function startup(){ setTimeout(function(){ preloadGalleryImages(); apply(); }, 250); }
    if (document.readyState === 'complete') startup();
    else window.addEventListener('load', startup);
  }
  function preloadGalleryImages(){
    // Desktop grid only: flip lazy photos to eager so they're all loaded (kills blank-on-scroll).
    // On the MOBILE slider we skip this — bulk-eagering 10+ photos at once bursts bandwidth and
    // flashes the main photo on load; mobile photos lazy-load smoothly as you swipe instead.
    var gallery = document.querySelector('[data-js-product-gallery]');
    if (!gallery) return;
    var slider = gallery.querySelector('css-slider');
    if (slider && slider.sliderEnabled) return;
    // Speed pass 2026-09-26: phones get the swipe slider (section-main-product.css turns it on at 767px and below). On a slow
    // phone the slider script is not running yet 150ms after DOMContentLoaded, so sliderEnabled was still false and this
    // flipped all 33 lazy photos to eager (about 4MB at once). Decide by screen width, which is known from the first moment.
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return;
    [].slice.call(gallery.querySelectorAll('.product-gallery-item img[loading="lazy"]')).forEach(function(im){
      im.setAttribute('loading', 'eager');
    });
  }
  function recolorStars(){
    // Convert each star layer's background image into a MASK (reusing the theme's exact star shapes),
    // then paint through it: filled stars take the live --fst-atc-color, empty stars stay neutral gray.
    function mask(el, color){
      if (!el || el.__fstMasked) return;
      var cs = getComputedStyle(el);
      var bg = cs.backgroundImage;
      if (!bg || bg === 'none') return;
      el.__fstMasked = true;
      el.style.setProperty('-webkit-mask-image', bg);
      el.style.setProperty('mask-image', bg);
      el.style.setProperty('-webkit-mask-repeat', cs.backgroundRepeat);
      el.style.setProperty('mask-repeat', cs.backgroundRepeat);
      el.style.setProperty('-webkit-mask-size', cs.backgroundSize);
      el.style.setProperty('mask-size', cs.backgroundSize);
      el.style.setProperty('-webkit-mask-position', cs.backgroundPosition);
      el.style.setProperty('mask-position', cs.backgroundPosition);
      el.style.setProperty('background-image', 'none');
      el.style.setProperty('background-color', color);
    }
    // Recolor only the FILLED layer to the live accent; the empty/outline layer keeps its original look.
    [].forEach.call(document.querySelectorAll('.fst-rating-row .star-rating__stars-active'), function(a){ mask(a, 'var(--fst-atc-color, #f5a623)'); });
  }
  function initFitFinder(){
    // Wire EVERY fit finder on the page — the inline one near the size selector AND the copy inside the size-guide drawer.
    [].forEach.call(document.querySelectorAll('[data-fst-fit]'), wireFit);
  }
  function wireFit(fit){
    if (!fit || fit.dataset.fstInit) return;
    fit.dataset.fstInit = '1';
    var toggle = fit.querySelector('[data-fst-fit-toggle]');
    var panel = fit.querySelector('[data-fst-fit-panel]');
    var prefBtns = [].slice.call(fit.querySelectorAll('[data-fst-fit-pref]'));
    var go = fit.querySelector('[data-fst-fit-go]');
    var result = fit.querySelector('[data-fst-fit-result]');
    if (!go) return;
    var pref = 'true';
    var ORDER = ['XS','S','M','L','XL','2XL','3XL','4XL'];
    function norm(s){
      s = (s||'').trim().toUpperCase();
      var map = { 'XXL':'2XL','XXXL':'3XL','XXXXL':'4XL','X-LARGE':'XL','XX-LARGE':'2XL','XXX-LARGE':'3XL','EXTRA SMALL':'XS','X-SMALL':'XS','SMALL':'S','MEDIUM':'M','LARGE':'L' };
      return map[s] || s;
    }
    function ftin(inch){ return Math.floor(inch/12) + "'" + (inch%12) + '"'; }
    function availSizes(){
      var arr = [];
      [].slice.call(document.querySelectorAll('.product-variant__item--radio:not(.product-variant__item--color) .product-variant__label')).forEach(function(l){
        var t = norm(l.textContent); if (ORDER.indexOf(t) >= 0 && arr.indexOf(t) < 0) arr.push(t);
      });
      return arr;
    }
    if (toggle && panel){ toggle.addEventListener('click', function(){
      if (panel.hasAttribute('hidden')){ panel.removeAttribute('hidden'); toggle.setAttribute('aria-expanded','true'); fit.classList.add('is-open'); }
      else { panel.setAttribute('hidden',''); toggle.setAttribute('aria-expanded','false'); fit.classList.remove('is-open'); }
    }); }
    var armed = false; // once they've clicked "Get my size", changing any input live-updates the result
    function liveUpdate(){ if (armed) compute(); }
    prefBtns.forEach(function(b){ b.addEventListener('click', function(){ pref = b.getAttribute('data-fst-fit-pref'); prefBtns.forEach(function(x){ x.classList.toggle('is-active', x === b); }); liveUpdate(); }); });
    function show(html){ result.innerHTML = html; result.removeAttribute('hidden'); }
    // Real review data baked into the product (custom.fit_data): fit distribution + height->size table.
    var FD = (function(){ try { return JSON.parse(fit.getAttribute('data-fst-fit-data') || 'null'); } catch(e){ return null; } })();
    var HLAB = ["4'11–5'2","5'3–5'5","5'6–5'8","5'9–5'11","6'0–6'2"];
    function hbk(inch){ if (inch <= 62) return 0; if (inch <= 65) return 1; if (inch <= 68) return 2; if (inch <= 71) return 3; return 4; }
    function clampAvail(idx){
      idx = Math.max(0, Math.min(ORDER.length - 1, idx));
      var rec = ORDER[idx], avail = availSizes();
      if (avail.length && avail.indexOf(rec) < 0){ var best = null, bd = 99; avail.forEach(function(a){ var d = Math.abs(ORDER.indexOf(a) - idx); if (d < bd){ bd = d; best = a; } }); if (best) rec = best; }
      return rec;
    }
    function compute(){
      var height = parseInt((fit.querySelector('[data-fst-fit-height]')||{}).value, 10) || 0;
      var trueSize = norm((fit.querySelector('[data-fst-fit-usual]')||{}).value);
      if (ORDER.indexOf(trueSize) < 0){ show('Pick your true size to get a recommendation.'); return; }
      // True size = the size you normally wear true to size. Loose = one size up. Oversized = two sizes up.
      var offset = (pref === 'oversized') ? 2 : (pref === 'loose' ? 1 : 0);
      var rec = clampAvail(ORDER.indexOf(trueSize) + offset);
      var lead = height ? ('At ' + ftin(height) + ' and a true size ' + trueSize + ', we recommend ') : 'We recommend ';
      var html = lead + 'size <b>' + rec + '</b>.';
      var proof = [];
      if (pref === 'loose') proof.push('One size up from your true size for a loose fit.');
      else if (pref === 'oversized') proof.push('Two sizes up from your true size for an oversized fit.');
      if (FD && height && FD.h && FD.h[hbk(height)] && FD.h[hbk(height)][0]){
        var b = hbk(height), rv = FD.h[b][0], dn = FD.h[b][1], diff = ORDER.indexOf(rv) - ORDER.indexOf(rec);
        // 2026-10-23: near-ties (FD.ha, e.g. "S/M/L") are said as a split, never as one winner.
        var alts = (FD.ha && FD.ha[b]) ? String(FD.ha[b]).toUpperCase().split('/') : [];
        var altTxt = alts.length > 2 ? alts.slice(0, -1).join(', ') + ' and ' + alts[alts.length - 1] : alts.join(' and ');
        if (alts.length > 1 && alts.indexOf(rec) >= 0) proof.push('Customers ' + HLAB[b] + ' were split between ' + altTxt + ' (' + dn + ' reviews), so ' + rec + ' is a common pick.');
        else if (alts.length > 1) proof.push('Customers ' + HLAB[b] + ' were split between ' + altTxt + ' (' + dn + ' reviews).');
        else if (diff === 0) proof.push("That's what most customers " + HLAB[b] + ' chose, too (' + dn + ' reviews).');
        else if (diff > 0) proof.push('Most customers ' + HLAB[b] + ' sized up to <b>' + rv + '</b> (' + dn + ' reviews). Pick Loose or Oversized for that.');
        else proof.push('Most customers ' + HLAB[b] + ' chose <b>' + rv + '</b> (' + dn + ' reviews).');
      }
      // Merchant override (custom.fit_scale, passed via data-fst-fit) wins; else derive the verdict from review data.
      var fsOverride = (fit.getAttribute('data-fst-fit') || '').trim();
      if (fsOverride === 'True size' || fsOverride === 'Loose' || fsOverride === 'Oversized'){
        var vmap = { 'True size': 'Fits true to size', 'Loose': 'Runs loose', 'Oversized': 'Runs oversized' };
        var vtxt = '<b>' + vmap[fsOverride] + '</b>';
        if (FD){ var vp = (fsOverride === 'True size') ? FD.tts : FD.over; proof.push(vtxt + ' (' + vp + '% of ' + FD.n + ' reviewers).'); }
        else { proof.push(vtxt + '.'); }
      }
      else if (FD){
        // State ONLY the dominant verdict, definitively — drop minority percentages so the customer gets one clear answer.
        var verdict, vpct;
        if (FD.tts >= FD.over && FD.tts >= FD.snug){ verdict = '<b>Fits true to size</b>'; vpct = FD.tts; }
        else if (FD.over >= FD.snug){ verdict = (FD.over >= 65) ? '<b>Runs oversized</b>' : '<b>Runs loose</b>'; vpct = FD.over; }
        else { verdict = '<b>Runs small, so size up</b>'; vpct = FD.snug; }
        proof.push(verdict + ' (' + vpct + '% of ' + FD.n + ' reviewers).');
      }
      else if (proof.length === 0){ proof.push('This style fits true to size.'); }
      if (proof.length) html += '<span class="fst-fit__proof">' + proof.join(' ') + '</span>';
      show(html);
      armed = true; // from now on, changing height / true size / fit pref updates the result instantly
    }
    go.addEventListener('click', compute);
    var hSel = fit.querySelector('[data-fst-fit-height]'), uSel = fit.querySelector('[data-fst-fit-usual]');
    if (hSel) hSel.addEventListener('change', liveUpdate);
    if (uSel) uSel.addEventListener('change', liveUpdate);
    // Relocate ONLY the inline "Find my fit" toggle up next to the Size Chart link. The drawer copy stays in its tab.
    if (toggle && !(fit.closest && fit.closest('.fst-sc-modal'))){
      (function relocate(){
        var anchor = document.querySelector('.jotly-size-anchor, .product-variant__size-chart-link');
        if (!anchor){ if ((relocate._n = (relocate._n||0)+1) < 30) setTimeout(relocate, 200); return; }
        if (toggle.dataset.fstMoved) return;
        toggle.dataset.fstMoved = '1';
        toggle.classList.add('fst-fit__toggle--inline');
        anchor.insertBefore(toggle, anchor.firstChild);
        var sizeBlock = anchor.closest('.product-variant');
        if (sizeBlock && fit.parentNode && sizeBlock.parentNode){ sizeBlock.parentNode.insertBefore(fit, sizeBlock.nextSibling); }
      })();
    }
  }
  function wireRatingScroll(){
    // Option B: the compact one-line rating button replaced the star widget; wire whichever exists.
    var rating = document.querySelector('.fst-rating-row [data-fst-proof-reviews]') || document.querySelector('.fst-rating-row .star-rating');
    if (!rating || rating.dataset.fstScroll) return;
    rating.dataset.fstScroll = '1';
    rating.style.cursor = 'pointer';
    rating.setAttribute('role', 'button');
    rating.setAttribute('tabindex', '0');
    rating.setAttribute('aria-label', 'Read customer reviews');
    // #looxReviews is CREATED BY loox.js at boot (it replaces the server-rendered reviews), so a tap
    // in the first seconds of the page can find it missing; fall back to the reviews SECTION wrapper,
    // which is server-rendered and always present.
    function go(){ var t = document.getElementById('looxReviews') || document.querySelector('[id^="shopify-section"][id$="__reviews"]'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    rating.addEventListener('click', go);
    rating.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); go(); } });
  }
  function wireRewardsLink(){
    // Append a "How rewards work" link to the Smile "Earn X points" block so customers can
    // one-tap to the rewards explainer. Smile renders async, so retry until the block exists.
    var tries = 0;
    (function attempt(){
      tries++;
      var block = document.querySelector('[id*="smile_io_smile_points_on_product_page"]')
               || document.querySelector('[id*="points_on_product_page"]');
      if (block && !block.querySelector('.fst-rw-pdp-link')) {
        // append as a flex sibling pinned to the RIGHT of the points text (block is display:flex
        // in cro-product.css) so it stays beside the text instead of stacking below it
        var a = document.createElement('a');
        a.className = 'fst-rw-pdp-link';
        a.href = '/pages/rewards';
        a.textContent = 'How it works →';
        block.appendChild(a);
        return;
      }
      if (tries < 120) setTimeout(attempt, 300); // keep trying ~36s while Smile's async block loads
    })();
  }
  function boot(){
    document.querySelectorAll('[data-fst-stock]').forEach(initStock);
    initSticky(); guardLoader(); wireRestockClick(); fillShipBy(); initColorGallery(); initFitFinder(); recolorStars(); wireRatingScroll(); wireRewardsLink();
    refreshAtc();
    setTimeout(refreshAtc, 400);
    setTimeout(preloadGalleryImages, 150); // desktop only (skips mobile slider) — load grid photos early
    // Update the button price ~2 frames after the variant resolves (once the theme has set
    // the [name=id] value) and in place — fast enough that there's no visible reload/movement.
    function scheduleAtc(){ requestAnimationFrame(function(){ requestAnimationFrame(refreshAtc); }); }
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t && (t.name === 'id' || (t.closest && (t.closest('product-variants') || t.closest('[data-js-product-variant]'))))) { scheduleAtc(); }
    });
    var pv = document.querySelector('product-variants[data-main-product-variants]') || document.querySelector('product-variants');
    if (pv) pv.addEventListener('VARIANT_CHANGE', scheduleAtc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
